import React from "react";
import { useAsync } from "react-async";
import { getPartnerSchoolInfo } from "services";
import { PartnerSchoolCard } from "./PartnerSchoolCard";

export function PartnerSchoolList(): JSX.Element {
  const { data } = useAsync({ promiseFn: getPartnerSchoolInfo });

  return (
    <>
      {data &&
        data
          .filter(partnerSchool => partnerSchool.display === true)
          .map(partnerSchool => (
            <PartnerSchoolCard key={partnerSchool.id} partnerSchool={partnerSchool} />
          ))}
    </>
  );
}
